import SetupHikDayabaySmsModal from './setup-hik-dayabay-sms-modal.vue'
export default SetupHikDayabaySmsModal
